export default __webpack_public_path__ + "static/media/b3206d35876b3ae0fa7340ee9780b819.d635ef10.png";